import api from 'api/api'
import { toast } from 'react-toastify'
import { urlPdfs } from 'constants/urls'
import { FILE_TYPE } from 'constants/file'
import { SALE_ITEM_STATUS, SALE_ORIGIN_TYPE } from 'constants/sales'
import { APP_URL } from 'constants/env'
import { downloadBase64File } from 'utils/donwload-base64-file'
import { PRIVATE_ROUTES } from 'router/routes'
import { printPDFfromURL } from 'utils/pdf'
import { DEFAULT_SALE_VOUCHER_A5_COMPANIES } from 'constants/companies'
import { getUserEstablishmentRuc } from 'utils/user-auth'

export const GET_SALES = '[SALES] GET SALES'
export const GET_ACCOUNTING_SALES = '[SALES] GET ACCOUNTING SALES'
export const GET_SALE_BY_ID = '[SALES] GET SALE BY ID'
export const RESET_SALE_BY_ID = '[SALES] RESET SALE BY ID'
export const SAVE_SALE = '[SALES] SAVE SALE'
export const UPDATE_SALE = '[SALES] UPDATE SALE'
export const FINISH_SALE = '[SALES] FINISH SALE'
export const VOID_SALE = '[SALES] VOID SALE'
export const SAVE_PRE_SALE_AS_ORDER_OR_PROFORMA = '[SALES] SAVE PRE SALE AS ORDER OR PROFORMA'

export const GET_SALES_BY_SELLER = '[SALES] GET SALES BY SELLER'

export const DOWNLOADING_SALES_BY_SELLER = '[SALES] DOWNLOADING SALES BY SELLER'

export const GET_SALE = '[SALES] GET SALE'

export const CRUD_SALE = '[SALES] CRUD SALE'

export const GET_PRICE_DOLLAR_SALES = '[SALES] GET PRICE DOLLAR'

export const GET_DATA_TYPE_PAYMENT = '[SALES] GET ALL TYPE PAYMENT'

export const GET_DATA_TYPE_PAYMENT_FROMS = '[SALES] GET ALL TYPE PAYMENT FROMS'

export const GET_DATA_SERIES_VOUCHER = '[SALES] GET ALL DATA SERIES BY VOUCHER'

export const GET_DATA_CORRELATIVE_SERIES_VOUCHER = '[SALES] GET DATA CORRELATIVE SERIES BY VOUCHER'

export const GET_DATA_COIN_TYPE = '[SALES] GET DATA COIN TYPE'

export function getSalesAction(filters = { startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/sales/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_SALES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SALES, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_SALES, error)
    }).finally(() => {
      dispatch({ type: GET_SALES, payload: { loading: false } })
    })
  }
}

export function getAccountingSalesAction(startDate, endDate) {
  const request = api.get(`/sales/accounting-registers/from/${startDate}/to/${endDate}`)
  return (dispatch) => {
    dispatch({ type: GET_ACCOUNTING_SALES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ACCOUNTING_SALES, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_ACCOUNTING_SALES, error)
    }).finally(() => {
      dispatch({ type: GET_ACCOUNTING_SALES, payload: { loading: false } })
    })
  }
}

export function getSaleByIdAction(saleId) {
  const request = api.get(`/sale/${saleId}`)
  return (dispatch) => {
    dispatch({ type: GET_SALE_BY_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_SALE_BY_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SALE_BY_ID, error)
    }).finally(() => {
      dispatch({ type: GET_SALE_BY_ID, payload: { loading: false } })
    })
  }
}

export function getSaleForCreditNoteAction(saleId) {
  const request = api.get(`/sale/for-credit-note/${saleId}`)
  return (dispatch) => {
    dispatch({ type: GET_SALE_BY_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_SALE_BY_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log('GET_SALE_FOR_CREDIT_NOTE', error)
      toast.error('Error al obtener datos de la venta para nota de crédito')
    }).finally(() => {
      dispatch({ type: GET_SALE_BY_ID, payload: { loading: false } })
    })
  }
}

export function saveSaleAction(data) {
  const request = api.post(`/sale/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_SALE, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_SALE, payload: { saved: true, data: response.data.data } })
      if (response.data.data?.estado_items === SALE_ITEM_STATUS.FINISHED) {
        if (response.data.data?.persona_correo) {
          dispatch(sendSaleToEmailAction({
            saleId: response.data.data?.facturacion_id,
            to: response.data.data?.persona_correo
          }))
        }
        if (DEFAULT_SALE_VOUCHER_A5_COMPANIES.includes(getUserEstablishmentRuc())) {
          printPDFfromURL(`${urlPdfs.ventaA4Half}/${response.data.data?.facturacion_id}`)
        } else {
          printPDFfromURL(`${urlPdfs.ventaTicket}/${response.data.data?.facturacion_id}`)
        }
      }
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_SALE, error)
    }).finally(() => {
      dispatch({ type: SAVE_SALE, payload: { saving: false } })
    })
  }
}

export function updateSaleAction(data) {
  const request = api.put(`/sale/update`, data)
  return (dispatch) => {
    dispatch({ type: UPDATE_SALE, payload: { updating: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_SALE, payload: { updated: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(UPDATE_SALE, error)
    }).finally(() => {
      dispatch({ type: UPDATE_SALE, payload: { updating: false } })
    })
  }
}

export function finishSaleAction(saleId) {
  const request = api.post(`/sale/finish/${saleId}`)
  return (dispatch) => {
    dispatch({ type: FINISH_SALE, payload: { finishing_id: saleId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: FINISH_SALE, payload: { finished_id: saleId, data: response.data.data } })
      if (response.data.data?.persona_correo) {
        dispatch(sendSaleToEmailAction({
          saleId: response.data.data?.facturacion_id,
          to: response.data.data?.persona_correo
        }))
      }
      printPDFfromURL(`${urlPdfs.ventaTicket}/${saleId}`)
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(FINISH_SALE, error)
    }).finally(() => {
      dispatch({ type: FINISH_SALE, payload: { finishing_id: saleId } })
    })
  }
}

export function voidSaleAction(saleId) {
  const request = api.post(`/sale/void/${saleId}`)
  return (dispatch) => {
    dispatch({ type: VOID_SALE, payload: { voiding_id: saleId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_SALE, payload: { voided_id: saleId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_SALE, error)
    }).finally(() => {
      dispatch({ type: VOID_SALE, payload: { voiding_id: saleId } })
    })
  }
}

export function sendSaleToEmailAction({ saleId, to }) {
  const request = api.post(`/sale/send-sale-to-email`, { saleId, to })
  return () => {
    toast.info(`Enviando comprobante a ${to}...`, { toastId: 'sendSaleToEmail', autoClose: false })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message, { toastId: 'sendSaleToEmail' })
        return
      }
      toast.success(response.data.message, { toastId: 'sendSaleToEmail' })
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'No se pudo enviar el comprobante', { toastId: 'sendSaleToEmail' })
      console.log(error)
    }).finally(() => {
      toast.update('sendSaleToEmail', { autoClose: 3000 })
    })
  }
}

export function savePreSaleAsOrderOrProformaAction(data) {
  const request = api.post(`/sale/save-pre-sale-as-order-or-proforma`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_PRE_SALE_AS_ORDER_OR_PROFORMA, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PRE_SALE_AS_ORDER_OR_PROFORMA, payload: { saved: true } })
      const tabRoute = data.tipo_origen === SALE_ORIGIN_TYPE.ORDER
        ? `${PRIVATE_ROUTES.ORDERS}?tab=orders-record`
        : `${PRIVATE_ROUTES.PROFORMAS}?tab=proformas-record`
      window.open(`${APP_URL}/${PRIVATE_ROUTES.PRIVATE}/${tabRoute}`, '_blank')
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_PRE_SALE_AS_ORDER_OR_PROFORMA, error)
    }).finally(() => {
      dispatch({ type: SAVE_PRE_SALE_AS_ORDER_OR_PROFORMA, payload: { saving: false } })
    })
  }
}

export function getSalesBySeller({
  sellerId = 0,
  startDate = '',
  endDate = '',
  status = '',
  brandId = 0,
  search = ''
}) {
  const request = api.get(`/venta/registros-por-vendedor`, {
    params: {
      vendedor_id: sellerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      estado: status,
      marca_id: brandId,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: GET_SALES_BY_SELLER, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_SALES_BY_SELLER, payload: { loading: false, ...response.data.detalles } })
    }).catch((error) => {
      dispatch({ type: GET_SALES_BY_SELLER, payload: { loading: false } })
      console.log(error);
    })
  }
}

export function downloadSalesBySellerPdf({
  sellerId = 0,
  startDate = '',
  endDate = '',
  status = '',
  brandId = 0,
  search = ''
}) {
  const request = api.get(`/venta/pdf-ventas-por-vendedor`, {
    params: {
      vendedor_id: sellerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      estado: status,
      marca_id: brandId,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.PDF,
        file: response.data.archivo
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function downloadSalesBySellerExcel({ sellerId = 0, startDate = '', endDate = '', status = '', brandId = 0, search = '' }) {
  const request = api.get(`/venta/excel-ventas-por-vendedor`, {
    params: {
      vendedor_id: sellerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      estado: status,
      marca_id: brandId,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.EXCEL,
        file: response.data.archivo
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function downloadItemsBySellerPdf({ sellerId = 0, startDate = '', endDate = '', status = '', brandId = 0, search = '' }) {
  const request = api.get(`/venta/pdf-items-por-vendedor`, {
    params: {
      vendedor_id: sellerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      estado: status,
      marca_id: brandId,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.PDF,
        file: response.data.archivo
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function downloadItemsBySellerExcel({ sellerId = 0, startDate = '', endDate = '', status = '', brandId = 0, search = '' }) {
  const request = api.get(`/venta/excel-items-por-vendedor`, {
    params: {
      vendedor_id: sellerId,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      estado: status,
      marca_id: brandId,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: true })
    request.then((response) => {
      downloadBase64File({
        filename: response.data.nombre,
        fileType: FILE_TYPE.EXCEL,
        file: response.data.archivo
      })
      toast.success('Se descargó el PDF.')
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      return
    }).catch((error) => {
      dispatch({ type: DOWNLOADING_SALES_BY_SELLER, payload: false })
      toast.error('Algo salió mal. No se pudo descargar el PDF.')
      console.error(error)
    })
  }
}

export function getSale({ saleId }) {
  const request = api.get(`/venta/obtener-venta?idventa=${saleId}`)
  return (dispatch) => {
    dispatch({ type: GET_SALE, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_SALE, payload: { loading: false, data: response.data.detalles } })
      setTimeout(() => {
        dispatch({ type: GET_SALE, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_SALE, payload: { loading: false, data: null } })
      toast.error("Error inesperado, no se pudo obtener la venta")
      console.log(error)
    })
  }
}


export function getPriceDollar() {
  const request = api.get(`/preciodollar`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: GET_PRICE_DOLLAR_SALES, payload: response.data.detalles })
    })
}

export function getCoinTypes() {
  const request = api.get(`/tipomoneda`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({ type: GET_DATA_COIN_TYPE, payload: response.data.detalles })
    })
}

export function getCorrelativeSeriesVoucher(form) {
  const request = api.get(
    `/seriexcomprobantexusuario/${form.idUser}/${form.idVoucher}/${form.idSerie}`
  )
  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_DATA_CORRELATIVE_SERIES_VOUCHER,
        payload: response.data.detalles,
      })
      setTimeout(() => {
        dispatch({ type: GET_DATA_CORRELATIVE_SERIES_VOUCHER, payload: {} })
      }, 50)
    })
}

export function getAllSeriesVoucher(form) {
  const request = api.get(`/seriexcomprobante/${form.idUser}/${form.idVoucher}`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_DATA_SERIES_VOUCHER,
        payload: response.data.detalles,
      })
    })
}

export function getAllTypesPayments() {
  const request = api.get(`/tipopago`)
  return (dispatch) =>
    request.then((response) => {
      return dispatch({
        type: GET_DATA_TYPE_PAYMENT,
        payload: response.data.detalles,
      })
    })
}

export function getPaymentForms(form) {
  const request = api.get(`/tipoformapago/${form}`)
  return (dispatch) =>
    request.then((response) => {
      dispatch({
        type: GET_DATA_TYPE_PAYMENT_FROMS,
        payload: response.data.detalles,
      })
    })
}